import type { BoardScheduler } from '../../types';
import type { IFuturePromise } from '../../../../utils/async-utils';
import { createFuturePromise } from '../../../../utils/async-utils';
import { EventScheduler } from '../../../../utils/EventScheduler';

export class BoardViewScheduler implements BoardScheduler {
  private readonly scheduler = new EventScheduler();

  private readonly idFPMap = new Map<string, IFuturePromise>();

  public wait(id: string | null, delay: number): Promise<void> {
    if (id === null) {
      return this.scheduler.wait(delay);
    }

    const fp = createFuturePromise();
    this.idFPMap.set(id, fp);
    return fp.promise;
  }

  public *waitGenerator(id: string | null, delay: number): Generator<void, void> {
    if (id === null) {
      const startTime = Date.now();
      while (Date.now() - startTime < delay) {
        yield;
      }
      return;
    }

    const fp = createFuturePromise();
    this.idFPMap.set(id, fp);

    // Wait for the promise to resolve
    while (!fp.isResolved()) {
      yield;
    }
  }

  public update(deltaTime: number): void {
    this.scheduler.update(deltaTime);
  }

  public finish(id: string): void {
    const fp = this.idFPMap.get(id);
    if (!fp) {
      console.warn(`BoardViewScheduler - no ${id}`);
      return;
    }

    this.idFPMap.delete(id);
    fp.resolve();
  }
}
